import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var addQuery = function addQuery(url, key, unencodedValue) {
  return addQueryParams(url, _defineProperty({}, key, unencodedValue));
};
export var addQueryParams = function addQueryParams(url, params) {
  if (!url) {
    return url;
  }
  var sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
  var paramsString = Object.entries(params).reduce(function (rest, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      unencodedValue = _ref2[1];
    if (!key) {
      return rest;
    }
    var nextPart = "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(unencodedValue));
    if (rest) {
      return "".concat(rest, "&").concat(nextPart);
    }
    return nextPart;
  }, '');
  if (!paramsString) {
    return url;
  }

  // If it has a query string already
  if (sanitisedUrl.includes('?')) {
    return "".concat(sanitisedUrl, "&").concat(paramsString);
  }
  return "".concat(sanitisedUrl, "?").concat(paramsString);
};